import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const PromptLLMSchema = z.object({
  language: languageEnumValidator.optional().default(LanguageEnum.EN),
  prompt: z.string().min(1, 'Prompt cannot be empty.'),
});

export type IPromptLLMDto = z.infer<typeof PromptLLMSchema>;
